/* ec-drag-scroll.js — EVRENSEL fare sürükle-kaydır.
   Yatay taşan her konteyneri (overflow-x: auto/scroll + içerik taşıyor) otomatik bulur,
   fare/pen ile tutup çekmeyi ekler. Dokunmatiğe KARIŞMAZ (native scroll).
   Snap konteynerlerde Chromium "snap geri-ışınlama" tuhaflığı çözülür:
   bırakınca en yakın snap çocuğuna elle oturtulur, snap sonra geri açılır. */
(function () {
  if (window.__ecDragScroll) return;
  window.__ecDragScroll = 1;

  function attach(track) {
    if (track.__ecDrag) return;
    track.__ecDrag = 1;
    track.style.cursor = 'grab';
    track.querySelectorAll('img, a').forEach(function (el) { el.draggable = false; });

    var down = false, moved = false, startX = 0, startLeft = 0, snapWas = '', behWas = '', hadSnap = false;

    function begin(e) {
      if (track.scrollWidth <= track.clientWidth + 4) return;
      down = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      /* setPointerCapture BURADA ALINMAZ: capture, click hedefini karttan konteynere
         kaydirip navigasyonu oldurur — yalniz gercek surukleme baslayinca alinir */
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      begin(e);
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) {
        /* pointerdown kaçmış olabilir: tuş basılıyken gelen ilk move başlangıçtır */
        if (e.pointerType === 'touch' || !(e.buttons & 1)) return;
        begin(e);
        return;
      }
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 12) { /* 4px cok sikiydi — normal tiklamadaki el kaymasi drag sayilip tiki yutuyordu */
        moved = true;
        track.style.cursor = 'grabbing';
        hadSnap = (getComputedStyle(track).scrollSnapType || 'none') !== 'none';
        snapWas = track.style.scrollSnapType;
        behWas = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto'; /* smooth, drag atamalarini animasyona cevirip geri savuruyor */
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
    });

    /* sürükleme sonrası tıklama sızmasın (link/kart açılmasın) */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    function stop() {
      if (!down) return;
      down = false;
      track.style.cursor = 'grab';
      if (!moved) return;
      /* snap hedefleri cocuk YA DA torun olabilir (ic track sarmalayicisi) */
      var kids = Array.prototype.filter.call(track.querySelectorAll(':scope > *, :scope > * > *'), function (k) {
        if (k.offsetWidth <= 0 || k.offsetWidth > track.clientWidth) return false;
        return (getComputedStyle(k).scrollSnapAlign || 'none') !== 'none';
      });
      if (!hadSnap || kids.length < 2) {
        requestAnimationFrame(function () { track.style.scrollSnapType = snapWas; track.style.scrollBehavior = behWas; });
        return;
      }
      if (kids.length) {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = null, bestD = Infinity;
        kids.forEach(function (k) {
          var mid = k.offsetLeft + k.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestD) { bestD = d; best = k; }
        });
        if (best) {
          var align = getComputedStyle(best).scrollSnapAlign || '';
          var target = align.indexOf('start') > -1
            ? best.offsetLeft - (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0)
            : best.offsetLeft - (track.clientWidth - best.offsetWidth) / 2;
          var max = track.scrollWidth - track.clientWidth;
          track.scrollLeft = Math.max(0, Math.min(max, target));
        }
      }
      requestAnimationFrame(function () { track.style.scrollSnapType = snapWas; track.style.scrollBehavior = behWas; });
    }
    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', stop);
    track.addEventListener('mouseleave', stop);
  }

  function scan() {
    document.querySelectorAll('main *, [id^="shopify-section"] *').forEach(function (el) {
      if (el.__ecDrag || el.childElementCount === 0) return;
      if (el.scrollWidth <= el.clientWidth + 4) return;
      var cs = getComputedStyle(el);
      if (cs.overflowX !== 'auto' && cs.overflowX !== 'scroll') return;
      attach(el);
    });
  }

  var t;
  function debouncedScan() { clearTimeout(t); t = setTimeout(scan, 250); }

  function boot() {
    scan();
    setTimeout(scan, 1200);             /* lazy içerik/AJAX rafları */
    window.addEventListener('resize', debouncedScan, { passive: true });
    var mo = new MutationObserver(debouncedScan);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', debouncedScan);
})();
